import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

export const useGetCustomerGroupReport = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const Api = useApi()
  const initialFilters = {
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
    customer_group_id: '',
  }
  const {filters, onDateChange, onSortingChange, setMultipleFilters} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/customer-groups', {
    queryId: 'customer-group-report',
    filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const onChangeCustomerGroupFilter = (values: any[]) => {
    setMultipleFilters({
      customer_group_id: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  return {
    reportData: response?.data || [],
    pagination: response?.meta?.pagination || {},
    isLoading: isFetching,
    handleCustomerGroupReportDateChange: onDateChange,
    filters,
    onSortingChange,
    onChangeCustomerGroupFilter,
  }
}
